import http from '@/api/HttpHelper'
import { saveAs } from 'file-saver'

const today = new Date()

const state = {
    data: [],
    totals: {
        sumAnnulledGiftcards: 0,
        sumLoadedGiftcards: 0,
        sumTransferredGiftcards: 0,
    },
    loading: false,
    from: new Date(today.getFullYear(), today.getMonth(), 1),
    to: new Date(today.getFullYear(), today.getMonth() + 1, 0),
    branch: localStorage.getItem('branch') || '',
}

const getters = {
    data (state) {
        return state.data
    },
    loading (state) {
        return state.loading
    },
    from (state) {
        return state.from
    },
    to (state) {
        return state.to
    },
    branch (state) {
        return state.branch
    },
    totals (state) {
        return state.totals
    }
}

const mutations = {
    setReportData (state, data) {
        state.data = data
    },
    setLoading (state, isLoading) {
        state.loading = isLoading
    },
    setFromDate (state, fromDate) {
        state.from = fromDate
    },
    setToDate (state, toDate) {
        state.to = toDate
    },
    setBranch (state, branch) {
        state.branch = branch
        localStorage.setItem('branch', branch)
    },
    setTotals (state, totals) {
        state.totals = totals
    }
}

const actions = {
    async getReportData ({ commit, state }) {
        commit('setLoading', true)
        const params = {
            from: `${state.from.getFullYear()}-${state.from.getMonth()+1}-${state.from.getDate()}`,
            to: `${state.to.getFullYear()}-${state.to.getMonth()+1}-${state.to.getDate()}`,
            branch: state.branch,
        }
        const result = await http.get('manualtransactions', {params: params})

        if (result.status === 200) {
            commit('setReportData', result.data.lines)
            const { lines, ...rest } = result.data
            commit('setTotals', rest)
        }
        
        commit('setLoading', false)
    },
    async getReportFile () {
        const params = {
            from: state.from,
            to: state.to,
            branch: state.branch,
        }
        const result = await http.get('manualtransactions/export', {params: params, responseType: 'blob'})
        if (result.status === 200) {
            saveAs(result.data, 'rapport.xlsx')
        }
    },
    setFromDate ({ commit, dispatch }, fromDate) {
        commit('setFromDate', fromDate)
        dispatch('getReportData')
    },
    setToDate ({ commit, dispatch }, toDate) {
        commit('setToDate', toDate)
        dispatch('getReportData')
    },
    setBranch ({ commit, dispatch }, branch) {
        commit('setBranch', branch)
        dispatch('getReportData')
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}